import React from 'react';

export default function AccountGridBox({ label, value }) {
	return (
		<div>
			<div className="fs-5 fw-light text-black">{label}</div>
			<div className="fs-6 fw-light text-black">{value}</div>
		</div>
	);
}
